import { checkFrontDoorEligibility } from '../routes/DonutsWithDiffit/eligibility';

// The same front-door check the /donuts-with-diffit route runs, asked before the ad
// is offered rather than after the click — otherwise the ad promises a session to
// teachers the front door will turn away, and the impression is already counted.
//
// Cached per session, keyed on nothing: the answer is per-user, not per-resource,
// and the badge + US gate in the registry keeps this to the small audience that
// could actually host. The route deliberately does NOT share this cache — a teacher
// who adds their school and returns must get a fresh answer there.
let pending = null;

export function isDonutsHostEligible() {
  if (!pending) {
    // Imported here rather than at the top, so the registry stays a table of data any
    // module can read: a static import would pull the axios instance — and the Clerk
    // client it builds at module scope — into the import graph of everything that reads
    // an AD_IDS constant, tests included.
    pending = import('../services/DonutsWithDiffitService')
      .then(({ getDonutsEligibility }) => getDonutsEligibility())
      .then((response) => checkFrontDoorEligibility(response.data).eligible)
      .catch(() => {
        // A transient failure isn't an answer: drop the cache so the next resource
        // view retries, but hide the ad for this one rather than guessing.
        pending = null;
        return false;
      });
  }
  return pending;
}
